const URL =  "https://ufoodapi.herokuapp.com";
export const createUserFollower = async (user_id,token) => {
  const response = await fetch(`${URL}/follow`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'Authorization': token.token
    },
    body: JSON.stringify({
      'id': user_id
    }),
  })

  return response.json();
}

export const deleteUserFollow = async (user_id,token) => {
  const response = await fetch(`${URL}/follow/${user_id}`, {
    method: 'DELETE',
    headers: {
      'Authorization': token.token
    },
  })

  return response.json();
}


